import { createSlice } from "@reduxjs/toolkit";
import { Template } from "../../@types/template";
import { createFileTemplate } from "../templateCreate/actions/createFileTemplate";
import { createTemplate } from "../templateCreate/actions/createTemplate";
import { deleteTemplate } from "../templateDetail/actions/deleteTemplate";
import { findTemplates } from "./actions/findTemplates";
import { findTemplatesAssignedToUser } from "./actions/findTemplatesAssignedToUser";
import { findTemplatesForUser } from "./actions/findTemplatesForUser";
import { findTemplatesForUserOrLocation } from "./actions/findTemplatesForUserOrLocation"

interface TemplateListState {
  findStatus: string;
  templates: Template[];
  findForUserLocationStatus: "idle" | "pending" | "succeeded" | "failed";
  findForUserStatus: "idle" | "pending" | "succeeded" | "failed";
  findTemplatesAssignedToUserStatus: "idle" | "pending" | "succeeded" | "failed";
  templatesAssignedToUser: [];
  templatesUserLocation: Template[];
  templatesForUser: Template[];
  searchText: string;
  ulSearchText: string;
  userTemplateSearchText: string;
  filterForFileTemplates: "all" | "location" | "user";
}

const initialState = {
  findStatus: "",
  templates: [],
  findForUserLocationStatus: "idle",
  findForUserStatus: "idle",
  findTemplatesAssignedToUserStatus: "idle",
  templatesAssignedToUser: [],
  templatesUserLocation: [],
  templatesForUser: [],
  searchText: "",
  ulSearchText: "",
  userTemplateSearchText: "",
  filterForFileTemplates: "all",
} as TemplateListState;


const templateListSlice = createSlice({
  name: "templateList",
  initialState,
  reducers: {
    setSearchText(state, { payload }) {
      state.searchText = payload;
    },
    setULSearchText(state, { payload }) {
      state.ulSearchText = payload;
    },
    setUserTemplateSearchText(state, { payload }) {
      state.userTemplateSearchText = payload;
    },
    setFilterForFileTemplates(state, { payload }) {
      state.filterForFileTemplates = payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(findTemplates.pending, (state) => {
        state.findStatus = "pending";
      })
      .addCase(findTemplates.rejected, (state) => {
        state.findStatus = "rejected";
      })
      .addCase(findTemplates.fulfilled, (state, { payload }) => {
        state.templates = payload.map(item => item);
        state.findStatus = "fulfilled";
      })
      .addCase(findTemplatesForUserOrLocation.pending, (state) => {
        state.templatesUserLocation = [];
        state.findForUserLocationStatus = "pending";
      })
      .addCase(findTemplatesForUserOrLocation.fulfilled, (state, { payload }) => {
        state.templatesUserLocation = payload.map((item: { id: number, name: string, assignedTo: string }) => {
          return { id: item.id, name: item.name, assignedTo: item.assignedTo }
        });
        state.findForUserLocationStatus = "succeeded";
      })
      .addCase(findTemplatesForUserOrLocation.rejected, (state) => {
        state.templatesUserLocation = [];
        state.findForUserLocationStatus = "failed";
      })
      .addCase(findTemplatesForUser.pending, (state) => {
        state.findForUserStatus = "pending";
      })
      .addCase(findTemplatesForUser.fulfilled, (state, { payload }) => {
        state.templatesForUser = payload;
        state.findForUserStatus = "succeeded"
      })
      .addCase(findTemplatesForUser.rejected, (state) => {
        state.findForUserStatus = "failed";
      })
      .addCase(createTemplate.fulfilled, (state, { payload }) => {
        state.templates.push(payload);
      })
      .addCase(createFileTemplate.fulfilled, (state, { payload }) => {
        state.templatesUserLocation.push({ id: payload.id, name: payload.name, assignedTo: payload.assignedTo });
      })
      .addCase(deleteTemplate.fulfilled, (state, { payload }) => {
        state.templates = state.templates.filter(({ id }) => id !== payload.deleted);
      })
      .addCase(findTemplatesAssignedToUser.pending, (state) => {
        state.findTemplatesAssignedToUserStatus = "pending";
      })
      .addCase(findTemplatesAssignedToUser.fulfilled, (state, {payload}) => {
        state.templatesAssignedToUser = payload;
        state.findTemplatesAssignedToUserStatus = "succeeded";
      })
      .addCase(findTemplatesAssignedToUser.rejected, (state) => {
        state.templatesAssignedToUser = [];
        state.findTemplatesAssignedToUserStatus = "failed";
      })
      ;
  },
});

export const 
{ 
  setSearchText, 
  setULSearchText, 
  setFilterForFileTemplates,
  setUserTemplateSearchText,
 } = templateListSlice.actions;

export default templateListSlice.reducer;
